module.exports = __webpack_public_path__ + "img/adv_stern_1.1644d335.png";